import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import KeycloakService from './services/KeycloakService';
import HttpService from './services/HttpService';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import MainTheme from './MainTheme';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const queryClient = new QueryClient();

const container = document.getElementById('root');
const root = createRoot(container);
const renderApp = () =>
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ThemeProvider theme={MainTheme}>
            <LocalizationProvider
              localeText={{ start: 'Start Date', end: 'End Date' }}
              dateAdapter={AdapterDayjs}
            >
              <App />
            </LocalizationProvider>
          </ThemeProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>,
  );
KeycloakService.initKeycloak(renderApp);
// renderApp();
HttpService.configure();

reportWebVitals();
